module.exports = function anonymous(it
) {
var out='<div>'+(it.msg || "Only available in an instance details' page")+'</div>';return out;
}